<template>
  <v-row justify="center" no-gutters>
    <v-col cols="12" xs="12" md="8">
      <v-container>
        <v-card>
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <UserAuthForm
              :submitForm="defaLogin"
              :errorMessage="errorMsg"
              :loading="loading"
              buttonText="Log in"
              :passwordToggle="true"
            />
          </v-card-text>
        </v-card>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import UserAuthForm from '../components/UserAuthForm'
import axios from '../axios-instance'

export default {
  name: 'Login',
  components: { UserAuthForm },
  data: function () {
    return {
      loading: false,
      errorMsg: ''

    }
  },

  methods: {
    defaLogin (formData) {
      let self = this
      this.loading = true
      this.errorMsg = ''
      axios({
        method: 'post',
        url: '/auth',
        data: formData
      })
        .then(r => {
          this.$store.dispatch('checkIfLoggedIn', true).then(function (response) {
            if (self.$route.query.redirect != null) {
              self.$router.push(self.$route.query.redirect)
            } else {
              self.$router.push({ name: 'home' })
            }
          })
        })
        .catch(e => {
          this.errorMsg = e.response.data.message
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}

</script>

<style scoped>

</style>
